import Udesk from 'Udesk';
import React, { FC, memo, useMemo } from 'react';
import { usePageParams } from '../hooks';
import NestHome from 'Component/common/nest-home-with-subnav';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    match?: any;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { id, isReady } = usePageParams(props);

    const navLists = useMemo(
        () => [
            {
                text: /* 基础信息 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.detail.index.basicInformation,
                pathName: getCurrentRouteName('productManageDetailBaseInfo'),
                pathParams: { id },
                isActive: (match, location) => {
                    return location.pathname.includes('/base-info');
                },
            },
            {
                text: /* 关联子产品 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.detail.index.associateSubproducts,
                pathName: getCurrentRouteName('productManageDetailSubProduct'),
                pathParams: { id },
                isActive: (match, location) => {
                    return location.pathname.includes('/sub-product');
                },
                disabled: !isReady,
            },
            {
                text: /* 关联原声数据 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.detail.index.associatesAcousticData,
                pathName: getCurrentRouteName('productManageDetailAcousticData'),
                pathParams: { id },
                isActive: (match, location) => {
                    return location.pathname.includes('/acoustic-data');
                },
                disabled: !isReady,
            },
        ],
        [id, isReady]
    );

    return <NestHome {...props} navLists={navLists} menuTitle={/* 产品管理 */UdeskLocales['current'].pages.conversationAnalysis.productManage.detail.index.productManagement} />;
});

class TemplateClass extends React.Component {
    render(): React.ReactNode {
        return <Template {...this.props} />;
    }
}

export default Udesk.react.udeskify(TemplateClass);
